import { Pipe, PipeTransform } from "@angular/core";
import { TimeSpan } from "../helpers/time-span";

@Pipe({
    name: "dateCustom",
    standalone: false
})
export class DateCustomPipe implements PipeTransform {
  transform(date: Date, format: string): string {
    if(date != null){

      const monthsLong = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
      const monthsShort = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
      let year = date.getFullYear();

      switch(format){
        case'month-long':
          let monthStringLong = monthsLong[date.getMonth()];
          return `${monthStringLong} ${year}`;
        case'month-short':
          let monthStringShort = monthsShort[date.getMonth()];
          return `${monthStringShort} ${year}`;
        default:
          let day = date.getDate().toString().padStart(2, '0');
          let month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0!
          return `${day}.${month}.${year}`;
      }
    }
    else {
      return null
    }
  }
}
